import React from 'react';
import LandingPage from '../components/LandingPage';
import HistoirePage from '../components/HistoirePage';
import TraditionPage from '../components/TraditionPage';
import GastronomiePage from '../components/GastronomiePage';
import CommunautePage from '../components/CommunautePage';
import ReliefClimatPage from '../components/ReliefClimatPage';
import MarketplacePage from '../components/MarketplacePage';
import AboutPage from '../components/AboutPage';
import NewsPage from '../components/NewsPage';
import ContactPage from '../components/ContactPage';

export interface PageConfig {
  path: string;
  component: React.ComponentType;
}

// Ordre des pages pour le carousel (ordre alphabétique)
export const pageOrder: PageConfig[] = [
  { path: '/', component: LandingPage },
  { path: '/gastronomie', component: GastronomiePage },
  { path: '/histoire', component: HistoirePage },
  { path: '/communaute', component: CommunautePage },
  { path: '/relief-climat', component: ReliefClimatPage },
  { path: '/tradition', component: TraditionPage },
  { path: '/marketplace', component: MarketplacePage },
];

// Toutes les pages (pour l'affichage) - ordre alphabétique pour les pages principales
export const allPages: PageConfig[] = [
  { path: '/', component: LandingPage },
  { path: '/gastronomie', component: GastronomiePage },
  { path: '/histoire', component: HistoirePage },
  { path: '/communaute', component: CommunautePage },
  { path: '/relief-climat', component: ReliefClimatPage },
  { path: '/tradition', component: TraditionPage },
  { path: '/marketplace', component: MarketplacePage },
  { path: '/about', component: AboutPage },
  { path: '/news', component: NewsPage },
  { path: '/contact', component: ContactPage },
];

